import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApprovalTypeEnum } from '@app/enums';
import { ApprovalLevelForEditModel } from '@app/models/system-settings/approval-level-for-edit.model';

@Injectable()
export class ApprovalSetupService {
	endpointBase = '/api/approvals-setup';

	constructor(private readonly http: HttpClient) {}

	getList(approvalType: ApprovalTypeEnum): Observable<any> {
		return this.http.get(`${this.endpointBase}/${approvalType.toString()}`);
	}

	getUsers(id: number, approvalType: ApprovalTypeEnum): Observable<any> {
		return this.http.get(`${this.endpointBase}/users`, {
			params: {
				Id: id.toString(),
				ApprovalType: approvalType.toString(),
			},
		});
	}

	saveApprovals(editedApprovals: ApprovalLevelForEditModel): Observable<any> {
		return this.http.put(this.endpointBase, editedApprovals);
	}
}
